// extracted by mini-css-extract-plugin
export default {"shell":"AppLayout_shell__MT6-r"};